import { FormLoadingSkeleton } from "../../../Patients/components/clinicalForms/formLayout";

const DailyLogSkeleton = () => <FormLoadingSkeleton />;

export default DailyLogSkeleton;
